module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1500.cfd6e797.svg";